import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const DomainSelectionPage = withSuspense(
	lazy(async () => await import('./domain-selection-page.component')),
	PageLoader,
);
